import React from 'react';
import { ExclamationCircleFill } from 'react-bootstrap-icons';
import { styled, keyframes } from '../../styles/stitches.config';

const slideIn = keyframes({
  from: { opacity: 0, transform: 'translateY(-8px)' },
  to: { opacity: 1, transform: 'translateY(0)' },
});

const RedBanner = styled('div', {
  width: '100%',
  padding: '0.75rem 1rem',
  backgroundColor: '$red2',
  border: '1px solid $red10',
  borderRadius: '0.5rem',
//   marginBottom: '1rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  fontSize: '0.875rem',
  color: '$red11',
  animation: `${slideIn} 250ms ease-out`,
});

const BannerText = styled('span', {
  lineHeight: 1.45,
  color: '$red11',

});

const RedStrong = styled('strong', {
  color: '$red11',
  fontWeight: 700,
});

const RedIcon = styled(ExclamationCircleFill, {
  fill: '$red11',
  flexShrink: 0,
});

interface VerificationRevokeWarningProps {
  threats: string[];
}

export const VerificationRevokeWarning: React.FC<VerificationRevokeWarningProps> = ({ threats }) => {
  if (threats.length === 0) return null;

  const formatted = threats.length === 1
    ? threats[0]
    : `${threats.slice(0, -1).join(', ')} and ${threats[threats.length - 1]}`;

  return (
    <RedBanner>
      <RedIcon size={16} />
      <BannerText>
        Removing <RedStrong>{formatted}</RedStrong> will revoke your verified status. You'll lose access to the search page until an admin re-verifies you.
      </BannerText>
    </RedBanner>
  );
};